import React from 'react'
import AuthLayout from '@SiteContainers/AuthLayout'

import './UsersSignUp.scss'

const UsersSignUp: React.FC = () => {
  return (
    <div className="UsersSignUp">
      <AuthLayout />
    </div>
  )
}

export default UsersSignUp
